export default {"src":"/_next/static/media/deco_checkout_creditcard.4c5ea0f9.svg","height":34,"width":55,"blurWidth":0,"blurHeight":0};